import { createSlice, PayloadAction } from '@reduxjs/toolkit';

let initial = 'es' 

const initialState = initial

const language = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state,action:PayloadAction<string>) => {
      return action.payload
      
    },
  },
 
});

// Reducer
export default language.reducer;

// Actions
export const {setLanguage} = language.actions;